import { map } from 'rxjs/operators'
import { StoreThunkDispatch } from 'store/state'
import * as api from './net'
import { toSavedFlag } from './utils'

export function getTikTokProfileSettings(ppid: string) {
  // EXPL: a record saved before the AI flag moved to the composer checkbox may still carry `isAiContent` - it is dropped
  // so it can never be restored
  return (dispatch: StoreThunkDispatch) => dispatch(api.getTikTokProfileSettings(ppid)).pipe(
    map(({ isAiContent: _ignored, ...response }: any) => ({
      ...response,
      enableComment: toSavedFlag(response.enableComment),
      enableDuet: toSavedFlag(response.enableDuet),
      enableStitch: toSavedFlag(response.enableStitch),
      autoAddMusic: toSavedFlag(response.autoAddMusic)
    }))
  )
}
